import { preloadHomeNavigation } from './HomeNavigation/preloadHomeNavigation';
import { preloadOverview } from './HomeViews/Overview/preloadOverview';
import { preloadRecent } from './HomeViews/Recent/preloadRecent';
import { preloadStarred } from './HomeViews/Starred/preloadStarred';
import { preloadDrafts } from './HomeViews/Drafts/preloadDrafts';
import { View } from './homeRouteParams';

type MatchParams = Record<string, string>;

type PreloadHomeOptions = {
	cloudId: string | null;
	isLicensed: boolean;
	userId: string | null;
	matchParams?: MatchParams;
	isSpaceAliasFFEnabled?: boolean;
	isWhiteboardViewedEnabled?: boolean;
	isDatabaseEnabled?: boolean;
};

const getSelectedView = (matchParams?: MatchParams) => {
	const view = matchParams?.view as View;
	return Object.values(View).includes(view) ? view : View.OVERVIEW;
};

const preloadSelectedView = ({
	cloudId,
	isLicensed,
	userId,
	matchParams,
	isSpaceAliasFFEnabled = false,
	isWhiteboardViewedEnabled = false,
	isDatabaseEnabled = false,
}: PreloadHomeOptions) => {
	if (!cloudId) {
		return Promise.resolve({});
	}
	const isLoggedIn = Boolean(userId);

	const selectedView = getSelectedView(matchParams);
	switch (selectedView) {
		case View.RECENT:
			return preloadRecent({
				cloudId,
				isLoggedIn,
				isWhiteboardViewedEnabled,
				isSpaceAliasFFEnabled,
			});
		case View.STARRED:
			return preloadStarred({ isLoggedIn, isSpaceAliasFFEnabled });
		case View.DRAFTS:
			return preloadDrafts({ isLoggedIn, isSpaceAliasFFEnabled });
		case View.OVERVIEW:
		default:
			return preloadOverview({
				userId,
				cloudId,
				isSpaceAliasFFEnabled,
				isLicensed,
				isWhiteboardViewedEnabled,
				isDatabaseEnabled,
			});
	}
};

export const preloadHome = (options: PreloadHomeOptions) => {
	return Promise.all([
		preloadHomeNavigation({
			isLoggedIn: Boolean(options.userId),
			isLicensed: options.isLicensed,
			isSpaceAliasFFEnabled: options.isSpaceAliasFFEnabled || false,
		}),
		preloadSelectedView(options),
	]).then(() => ({ data: {} }));
};
